import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../ui/accordion";
import { ChapterHeading } from "../ChapterHeading";
import { Reveal } from "../motion/Reveal";

const FAQS = [
  {
    q: "Is this AI-generated?",
    a: "SayIt was built using AI-assisted writing and independent QA, followed by human editorial review and full product-level regression auditing. The finished messages are curated outputs, not raw one-shot AI responses.",
  },
  {
    q: "Can I copy the messages directly?",
    a: "Yes. Customize the bracketed details to match the facts of your situation before using the message.",
  },
  {
    q: "Can my whole company use it?",
    a: "The launch purchase is intended for individual use by the purchaser. Team or company licensing may be introduced separately.",
  },
  {
    q: "Does this replace HR or legal advice?",
    a: "No. Some workplace situations depend on local employment law, company policy, contracts or organisational process. Sensitive situations are flagged for appropriate review.",
  },
  {
    q: "What format do I receive?",
    a: "A professionally designed 117-page PDF/digital product containing all 100 management situations.",
  },
  {
    q: "Is this a subscription?",
    a: "No. It is a one-time purchase.",
  },
  {
    q: "Can I use it outside Malaysia?",
    a: "Yes. The language is designed to be broadly usable internationally. Employment-specific situations should still be checked against local HR, policy and legal requirements.",
  },
  {
    q: "What currency will I be charged in?",
    a: "All purchases are charged in USD at one global launch price of US$2.99, wherever you are buying from.",
  },
];

export function Faq() {
  return (
    <section id="faq" className="py-20 sm:py-28">
      <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
        <ChapterHeading index="09" eyebrow="FAQ" title="Questions, answered." />
        <Reveal delay={0.1} className="mt-12 max-w-3xl">
          <Accordion type="single" collapsible className="w-full">
            {FAQS.map((f, i) => (
              <AccordionItem
                key={f.q}
                value={`item-${i + 1}`}
                data-testid={`faq-accordion-item-${i + 1}`}
                className="border-line"
              >
                <AccordionTrigger className="text-left text-base font-medium text-ink hover:no-underline">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-sm leading-relaxed text-smoke">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
}
